import * as React from 'react';
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import { cn } from '@/utils/cn';
import styles from './Chip.module.scss';
import type { ChipProps, ChipRef } from './Chip.types';

/**
 * Chip - Selectable chip item (must be used inside ChipGroup)
 * Based on Radix UI Toggle Group Item
 * Selected state is driven by Radix (data-state="on")
 *
 * @example
 * <ChipGroup value={filter} onValueChange={setFilter}>
 *   <Chip value="grammar">Grammar</Chip>
 * </ChipGroup>
 */
export const Chip = React.forwardRef<ChipRef, ChipProps>(
  ({ value, children, className, disabled, ...props }, ref) => {
    return (
      <ToggleGroupPrimitive.Item
        ref={ref}
        value={value}
        disabled={disabled}
        className={cn(styles.chip, className)}
        {...props}
        data-no-press-scale=""
      >
        {children}
      </ToggleGroupPrimitive.Item>
    );
  }
);

Chip.displayName = 'Chip';
